import { IReactiveModel, ViewModel } from '@descomplica/microfrontend-core';
import { action, makeAutoObservable, observable } from 'mobx';

import type { OrganizationDto } from '@/shared/application/interfaces/pegasus-io.gateway';

import {
  GetOrganizationCollaboration,
  ORGANIZATION_OBTAINED,
} from '../../application/collaborations/get-organization.collaboration';

@ViewModel({ singleton: true })
export class OrganizationViewModel implements IReactiveModel {
  @observable organization: OrganizationDto;
  @observable isLoading = false;
  @observable hasError = false;
  @observable isCreateModalOpen = false;
  @observable isLoadingRoles = false;
  @observable isSubmitting = false;

  constructor(private getOrganizationCollaboration: GetOrganizationCollaboration) {
    makeAutoObservable(this);
  }

  @action
  async onInit(props) {
    try {
      this.isLoading = true;
      const org = await this.getOrganizationCollaboration.run(props.guid);
      if (org?.identifier !== ORGANIZATION_OBTAINED) {
        throw new Error('Erro ao obter organização');
      }
      this.organization = org.data;
    } catch (error) {
      console.error(error);
      this.hasError = true;
    } finally {
      this.isLoading = false;
    }
  }
}
